'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const PhoneIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="PhoneIcon">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_278_9396)">
          <path
            d="M9.086 7.4C9.51925 6.96598 9.76259 6.37777 9.76259 5.7645C9.76259 5.15124 9.51925 4.56303 9.086 4.129L6.63199 1.678C6.19823 1.24426 5.60992 1.00058 4.9965 1.00058C4.38307 1.00058 3.79476 1.24426 3.361 1.678L2.016 3.024C1.45009 3.58901 1.09717 4.33246 1.01714 5.12812C0.937121 5.92379 1.13493 6.72262 1.577 7.389C5.5379 13.3509 10.6491 18.4621 16.611 22.423C17.2776 22.8645 18.0763 23.0621 18.8719 22.9825C19.6674 22.9028 20.4111 22.5508 20.977 21.986L22.322 20.64C22.5369 20.4253 22.7074 20.1703 22.8237 19.8897C22.94 19.6091 22.9998 19.3083 22.9998 19.0045C22.9998 18.7007 22.94 18.3999 22.8237 18.1193C22.7074 17.8387 22.5369 17.5837 22.322 17.369L19.869 14.916C19.6543 14.7011 19.3993 14.5306 19.1187 14.4143C18.8381 14.298 18.5373 14.2382 18.2335 14.2382C17.9297 14.2382 17.6289 14.298 17.3483 14.4143C17.0677 14.5306 16.8127 14.7011 16.598 14.916L15.78 15.734C13.0389 13.4782 10.5231 10.9617 8.26799 8.22L9.086 7.4Z"
            stroke={sx?.color || '#3D517B8F'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    </SvgIcon>
  )
}

PhoneIcon.propTypes = {
  sx: PropTypes.object
}
